import { PricingInvoiceHistoryEntry } from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store-types';
import { PricingInvoiceHistoryFieldsFragment } from '@/types';

export const toPricingInvoiceHistory = (
  entries: PricingInvoiceHistoryFieldsFragment[],
): PricingInvoiceHistoryEntry[] =>
  entries.map((entry) => ({
    grossMarginPercentage: entry.gross_margin_percentage ?? null,
    invoiceDate: entry.invoice_date,
    priceInMicros: entry.price_in_micros ?? null,
    quantity: entry.quantity,
  }));
